<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            d="M12 2c-.5523 0-1 .44772-1 1v1.06001c-1.08847.26514-1.92014 1.37888-1.99457 2.74069-.45236.26052-.87254.58113-1.24807.95666C6.63214 8.88258 6 10.4087 6 12h12c0-1.5913-.6321-3.11742-1.7574-4.24264-.3755-.37553-.7957-.69614-1.248-.95666-.0745-1.36181-.9061-2.47555-1.9946-2.74069V3c0-.55228-.4477-1-1-1Z"
        />
        <path
            fill-rule="evenodd"
            d="M4 14.2c0-.6627.53489-1.2 1.19471-1.2H18.8053C19.4651 13 20 13.5373 20 14.2s-.5349 1.2-1.1947 1.2H18.3v4.2h.6545C20.0842 19.6 21 20.6745 21 22H3c0-1.3255.91578-2.4 2.04545-2.4H5.7v-4.2h-.50529C4.53489 15.4 4 14.8627 4 14.2Zm11.9 5.4v-4.2h-1v4.2h1Zm-4.4-4.2h1v4.2h-1v-4.2Zm-2.40001 4.2v-4.2H8.1v4.2h.99999Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M12 2c-.552 0-1 .448-1 1v1.229c-.418.197-.802.517-1.121.943-.187.249-.347.528-.477.828-.108.248-.195.511-.26.784-.772.444-1.482 1.068-2.092 1.852C6.111 9.844 5.466 11.36 5.175 13H4c-.552 0-1 .448-1 1s.448 1 1 1h1v5c-1.105 0-2 .895-2 2h18c0-1.105-.895-2-2-2v-5h1c.552 0 1-.448 1-1s-.448-1-1-1h-1.175c-.291-1.64-.936-3.156-1.875-4.364-.61-.784-1.32-1.408-2.092-1.852-.065-.273-.152-.536-.26-.784-.13-.3-.29-.579-.477-.828-.319-.426-.703-.746-1.121-.943V3c0-.552-.448-1-1-1Zm0 6c-1.141 0-2.372.58-3.371 1.864-.659.848-1.153 1.93-1.416 3.136h9.574c-.263-1.206-.756-2.288-1.416-3.136C14.372 8.58 13.141 8 12 8ZM7 20v-5h2v5H7Zm10-5v5h-2v-5h2Zm-4 0v5h-2v-5h2Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
